<template>
    <section class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header p-2">
                            <ul class="nav nav-pills">
                                <li class="nav-item"><a class="nav-link active show" href="#profile" data-toggle="tab">{{
                                        $t('profile')
                                    }}</a>
                                </li>
                                <li class="nav-item"><a class="nav-link" href="#change-password" data-toggle="tab">Change
                                    Password</a></li>
                            </ul>
                        </div><!-- /.card-header -->
                        <div class="card-body">
                            <div class="tab-content">
                                <!-- profile Tab -->
                                <div class="tab-pane active show" id="profile">

                                    <text-input :form="form" :readonly="true" :label="$t('company_name')"
                                                name="company_name"/>
                                    <text-input v-if="form.type === 1" :form="form" :label="$t('vat_number')"
                                                name="vat_number"/>

                                    <div class="form-group">
                                        <label class="col-sm-12 control-label">{{ $t('notifications_enabled') }}</label>

                                        <div class="col-sm-3">
                                            <input type="radio"
                                                   v-model="form['notifications_enabled']"
                                                   :class="{ 'is-invalid': form.errors.has('notifications_enabled') }"
                                                   value="1"
                                            > Yes
                                            <input type="radio"
                                                   v-model="form['notifications_enabled']"
                                                   :class="{ 'is-invalid': form.errors.has('notifications_enabled') }"
                                                   value="0"
                                            > No
                                        </div>
                                    </div>

                                    <h4 class="pl-3 pt-3 pb-2">{{ $t('Main contact') }}</h4>

                                    <text-input :form="form" :readonly="true" :label="$t('first_name')"
                                                name="first_name"/>
                                    <text-input :form="form" :readonly="true" :label="$t('last_name')"
                                                name="last_name"/>
                                    <text-input :form="form" :readonly="true" :label="$t('Email')"
                                                name="email"/>

                                    <h4 class="pl-3 pt-3 pb-2">{{ $t('address') }}</h4>

                                    <text-input :form="form" :label="$t('address')"
                                                name="address"/>
                                    <text-input :form="form" :label="$t('City')"
                                                name="city"/>
                                    <text-input :form="form" :label="$t('Postcode')"
                                                name="postcode"/>
                                    <select-input :label="$t('Country')"
                                                  :form="form"
                                                  name="country_id"
                                                  :options="$countries"/>

                                    <div class="form-group">
                                        <div class="col-sm-12 text-right">
                                            <button @click.prevent="update" type="submit"
                                                    class="btn btn-success">{{ $t('save') }}
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <!-- Setting Tab -->
                                <div class="tab-pane" id="change-password">
                                    <form class="form-horizontal">
                                        <text-input :form="passwordForm" type="password" :label="$t('current_password')"
                                                    name="current_password"/>

                                        <text-input :form="passwordForm" type="password" :label="$t('password')"
                                                    name="password"/>

                                        <text-input :form="passwordForm" type="password"
                                                    :label="$t('password_confirmation')"
                                                    name="password_confirmation"/>

                                        <div class="form-group">
                                            <div class="col-sm-offset-2 col-sm-12">
                                                <button @click.prevent="updatePassword" type="submit"
                                                        class="btn btn-success">Update Password
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <!-- /.tab-pane -->
                            </div>
                            <!-- /.tab-content -->
                        </div><!-- /.card-body -->
                    </div>
                    <!-- /.nav-tabs-custom -->
                </div>
                <!-- end tabs -->
            </div>
        </div>
    </section>
</template>

<script>
import TextInput from "../shared/components/TextInput";
import SelectInput from "../shared/components/SelectInput";

export default {
    name: "Profile",
    components: {TextInput, SelectInput},
    data() {
        return {
            form: new Form(),

            passwordForm: new Form({
                current_password: '',
                password: '',
                password_confirmation: ''
            })
        }
    },
    mounted() {
        console.log('Component mounted.')
    },
    methods: {
        update() {
            this.$Progress.start();
            this.form.put('/api/v1/rights-owners/profile')
                .then((data) => {
                    //  Fire.$emit('AfterCreate');
                    this.$Progress.finish();
                    Toast.fire({
                        icon: 'success',
                        title: data.data.message
                    });
                })
                .catch(() => {
                    this.$Progress.fail();
                    Toast.fire({
                        icon: 'error',
                        title: 'Some error occured! Please try again'
                    });
                });
        },
        updatePassword() {
            this.$Progress.start();
            this.passwordForm.post('/api/v1/rights-owners/change-password')
                .then((data) => {
                    //  Fire.$emit('AfterCreate');
                    this.$Progress.finish();
                    this.passwordForm.current_password = '';
                    this.passwordForm.password = '';
                    this.passwordForm.password_confirmation = '';
                    Toast.fire({
                        icon: 'success',
                        title: data.data.message
                    });
                })
                .catch(() => {
                    this.$Progress.fail();
                    Toast.fire({
                        icon: 'error',
                        title: 'Some error occured! Please try again'
                    });
                });
        }
    },
    created() {
        this.$Progress.start();
        axios.get("/api/v1/rights-owners/profile")
            .then((response) => {
                this.form = new Form(response.data.data)
            });
        this.$Progress.finish();
    }
}
</script>

<style scoped>

</style>
